import { flashToast } from '@/toast.js'

export function usePromotion(sections) {
    const sectionsMap = new Map(sections.map(s => [s.id, s]))

    const getSectionClasses = (sectionId) =>
        sectionsMap.get(sectionId)?.classes ?? []

    const getNextClass = (cls) =>
        cls.next_class_room
            ? { id: cls.next_class_room.id, name: cls.next_class_room.name }
            : { id: null, name: 'Graduation' }

    const getAvailableSubjects = (sectionId, fromClassId, currentSubjects, currentId = null) => {
        const cls = getSectionClasses(sectionId).find(c => c.id === fromClassId)
        if (!cls) return []
        return cls.subjects
            .filter(s => s.id === currentId || !currentSubjects.some(rs => rs.id === s.id))
            .map(s => ({ label: s.name, value: s.id }))
    }

    const changeSubject = (rule, subjectIndex, newSubjectId, sectionId) => {
        const cls     = getSectionClasses(sectionId).find(c => c.id === rule.from_class_id)
        const subject = cls?.subjects.find(s => s.id === newSubjectId)
        if (!subject) return
        rule.subjects[subjectIndex] = { ...rule.subjects[subjectIndex], id: subject.id, name: subject.name }
    }

    const commitSubject = (rule, sectionId) => {
        if (!rule.draft.subject_id) return
        const cls     = getSectionClasses(sectionId).find(c => c.id === rule.from_class_id)
        const subject = cls?.subjects.find(s => s.id === rule.draft.subject_id)
        if (!subject) return
        rule.subjects.push({ id: subject.id, name: subject.name, min_score: rule.draft.min_score })
        rule.draft.subject_id = null
        rule.draft.min_score  = 40
        rule.addingSubject    = false
    }

    const cancelAddSubject = (rule) => {
        rule.draft.subject_id = null
        rule.draft.min_score  = 40
        rule.addingSubject    = false
    }

    const startAddSubject = (rule, sectionId) => {
        if (!getAvailableSubjects(sectionId, rule.from_class_id, rule.subjects).length) {
            flashToast({ type: 'info', message: 'All subjects have already been added to this class' })
            return
        }
        rule.addingSubject = true
    }

    const removeSubject = (rule, subjectId) => {
        rule.subjects = rule.subjects.filter(s => s.id !== subjectId)
    }

    return {
        getSectionClasses,
        getNextClass,
        getAvailableSubjects,
        changeSubject,
        commitSubject,
        cancelAddSubject,
        startAddSubject,
        removeSubject,
    }
}